export const selected = (value: any) => !!value;
